"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = exports.configureStore = void 0;
var _redux = require("redux");
var _reduxThunk = require("redux-thunk");
var _reduxLogger = require("redux-logger");
var _Reducer = require("./Reducer");
// MIDDLEWARES
const enhancers = [];
const middlewares = [_reduxThunk.thunk];
const getIfDev = typeof window !== 'undefined' ? window.location.href.split('?') : [];
// @ts-ignore
if (typeof window !== 'undefined' && (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === '6006' || getIfDev[1] && getIfDev[1].includes('dev=true'))) {
  const logger = (0, _reduxLogger.createLogger)({
    duration: true,
    timestamp: false,
    collapsed: true,
    colors: {
      title: () => '#139BFE',
      prevState: () => '#1C5FAF',
      action: () => '#149945',
      nextState: () => '#A47104',
      error: () => '#ff0005'
    }
  });
  middlewares.push(logger);
}
const composedEnhancers = (0, _redux.compose)((0, _redux.applyMiddleware)(...middlewares), ...enhancers);
// @ts-ignore
const configureStore = initialStore => (0, _redux.createStore)(_Reducer.rootReducer, initialStore, composedEnhancers);
exports.configureStore = configureStore;
const store = exports.store = (0, _redux.createStore)(_Reducer.rootReducer);